//  icons
import {
  FiYoutube,
  FiInstagram,
  FiGithub,
  FiDribbble,
  FiLayout,
  FiSettings,
  FiPenTool,
  FiTag,
  FiMail,
  FiMapPin,
  FiLinkedin,
  FiMessageCircle,
  FiMessageSquare,
} from 'react-icons/fi';
// import { SocialMediaIconsReact } from 'social-media-icons-react';

// companies icons
import FreelancerBrandIcon from './assets/img/brands/freelancer.png';
import UpworkBrandIcon from './assets/img/brands/upwork.png';
import FiverBrandIcon from './assets/img/brands/fiverr.png';
import BehanceBrandIcon from './assets/img/brands/behance.png';
import DribbbleBrandIcon from './assets/img/brands/dribbble.png';

// projects images
import Project1 from './assets/img/projects/p1.png';
import Project2 from './assets/img/projects/p4.png';
import Project3 from './assets/img/projects/p7.png';
import Pro1 from './assets/img/projects/p1.png';
import Pro2 from './assets/img/projects/p2.png';
import Pro3 from './assets/img/projects/p3.png';
import Pro4 from './assets/img/projects/p4.png';
import Pro5 from './assets/img/projects/p5.png';
import Pro6 from './assets/img/projects/p6.png';
import Pro7 from './assets/img/projects/p7.png';
import Pro8 from './assets/img/projects/p8.png';
import Pro9 from './assets/img/projects/p9.png';
// import Project4 from './assets/img/projects/p4.webp';
// import Project5 from './assets/img/projects/p5.webp';
// import Project6 from './assets/img/projects/p6.webp';

// skills images
import SkillImg1 from './assets/img/skills/html5.png';
import SkillImg2 from './assets/img/skills/css3.png';
import SkillImg3 from './assets/img/skills/js.png';
import SkillImg4 from './assets/img/skills/reactjs.png';
import SkillImg5 from './assets/img/skills/nodejs (2).png';
import SkillImg6 from './assets/img/skills/MongoDB_logo_01.png';
import SkillImg7 from './assets/img/skills/git.png';
import SkillImg8 from './assets/img/skills/figma.png';

// testimonial images
import TestiImage1 from './assets/img/testimonials/testimonial-1.webp';
import TestiImage2 from './assets/img/testimonials/testimonial-2.webp';
import TestiImage3 from './assets/img/testimonials/testimonial-3.webp';

// navigation
export const navigation = [
  {
    name: 'home',
    href: 'home',
  },
  {
    name: 'about',
    href: 'about',
  },
  {
    name: 'portfolio',
    href: 'portfolio',
  },
  // {
  //   name: 'services',
  //   href: 'services',
  // },
  // {
  //   name: 'testimonials',
  //   href: 'testimonials',
  // },
  {
    name: 'contact',
    href: 'contact',
  },

];

// social
export const social = [
  // {
  //   icon: <FiYoutube />,
  //   href: '',
  // },

  {
    icon: <FiGithub />,
    href: 'https://github.com/Avisheik1721158',
  },

  {
    icon: <FiLinkedin />,
    href: 'https://www.linkedin.com/in/avisheik-barua-76b3b6187/',
  },
  {
    icon: <FiInstagram />,
    href: 'https://www.instagram.com/avisheik_barua/',
  },
  {
    icon: <FiMail />,
    href: 'mailto:avisheikbarua960@gmail.com',
  },
  // {
  //   icon: <FiDribbble />,
  //   href: '',
  // },
];

// companies
export const brands = [
  {
    img: FreelancerBrandIcon,
    href: '',
  },
  {
    img: UpworkBrandIcon,
    href: '',
  },
  {
    img: FiverBrandIcon,
    href: '',
  },
  {
    img: BehanceBrandIcon,
    href: '',
  },
  {
    img: DribbbleBrandIcon,
    href: '',
  },
];

// projects
export const projectsData = [
  {
    id: '1',
    image: Project1,
    detailsImg: Pro1,
    detailsImg1: Pro2,
    detailsImg2: Pro3,


    name: 'Bits and Bytes',
    category: 'Full Stack',
    description: 'Admin can add, edit, delete products, delete users, make a user as admin, check orders, and mark orders as delivered.',
    info: 'Manufactured items, user rating and comments, product page, quantity select, user profile page, and payment system. Admin can add, edit, delete products, delete users, make a user as admin, check orders, and mark orders as delivered. Stack: React, Nodejs, Expressjs, Firebase, MongoDB, HTML, Tailwind, DaisyUI etc.'
  },
  {
    id: '2',
    image: Project2,
    detailsImg: Pro4,
    detailsImg1: Pro5,
    detailsImg2: Pro6,
    name: 'Fitness Warehouse',
    category: 'Full Stack',
    description: 'Gym Equipment, cart, user rating and comment, product page, quantity select, Stock update, Admin can add or delete products.',
    info: 'Gym Equipment, cart, user rating and comment, product page, quantity select, Stock update, Admin can add or delete products.Stack: React, React tailwind, Nodejs, MongDB, HTML, etc.'
  },
  {
    id: '3',
    image: Project3,
    detailsImg: Pro7,
    detailsImg1: Pro8,
    detailsImg2: Pro9,
    name: 'Tutor-Academy',
    category: 'Full Stack',
    description: 'It is a tutor side where users can buy their crash course. Users should log in before buying any course',
    info: 'It is a tutor side where users can buy their crash course.Users should log in before buying any course.Stack: React, React tailwind, Nodejs, MongoDB, HTML, MongoDB etc'
  },
  // {
  //   id: '4',
  //   image: Project4,
  //   name: 'project name 4',
  //   category: 'branding',
  // },
  // {
  //   id: '5',
  //   image: Project5,
  //   name: 'project name 5',
  //   category: 'web development',
  // },
  // {
  //   id: '6',
  //   image: Project6,
  //   name: 'project name 6',
  //   category: 'web development',
  // },
];

// projects
export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'UI/UX Design',
  },
  {
    name: 'web development',
  },
  {
    name: 'branding',
  },
];

// skill
export const skills = [
  {
    image: SkillImg1,
  },
  {
    image: SkillImg2,
  },
  {
    image: SkillImg3,
  },
  {
    image: SkillImg4,
  },
  {
    image: SkillImg5,
  },
  {
    image: SkillImg6,
  },
  {
    image: SkillImg7,
  },
  {
    image: SkillImg8,
  },
];

// services
export const services = [
  {
    icon: <FiLayout />,
    name: 'Web Design',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.',
  },
  {
    icon: <FiSettings />,
    name: 'Web Development',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.',
  },
  {
    icon: <FiPenTool />,
    name: 'Branding',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.',
  },
  {
    icon: <FiTag />,
    name: 'SEO',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.',
  },
];

// testimonials
export const testimonials = [
  {
    authorImg: TestiImage1,
    authorText:
      'Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.',
    authorName: 'Olivia Doe',
    authorPosition: 'Head of Design, Google',
  },
  {
    authorImg: TestiImage2,
    authorText:
      'Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.',
    authorName: 'Olivia Doe',
    authorPosition: 'Head of Design, Google',
  },
  {
    authorImg: TestiImage3,
    authorText:
      'Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.',
    authorName: 'Olivia Doe',
    authorPosition: 'Head of Design, Google',
  },
];

// contact
export const contact = [
  {
    icon: <FiMail />,
    title: 'Any question?',
    subtitle: 'Feel free to share your feedback',
    description: 'Email me at avisheikbarua960@gmail.com',
  },
  {
    icon: <FiMapPin />,
    title: 'Current Location',
    subtitle: 'North Askar dighi, Chittagong',
    description: 'Serving clients worldwide',
  },
];
